import PropTypes from 'prop-types';

import FormWrapper from 'components/AbroadComponentsV2/SharedComponents/LeadForm/FormWrapper';

import withFilterUtils from 'hocs/withFilterUtils';
import { LeadProvider } from 'providers/LeadProvider';

LeadForm.propTypes = {
  buttonText: PropTypes.string,
  cityId: PropTypes.number,
  countryId: PropTypes.number,
  courseId: PropTypes.number,
  id: PropTypes.string,
  onMessageSuccess: PropTypes.instanceOf(Function),
  onSubmitSecondStep: PropTypes.instanceOf(Function),
  schoolsFilters: PropTypes.instanceOf(Object),
  shouldScheduleMeeting: PropTypes.bool,
  useParentProvider: PropTypes.bool,
};

function LeadForm({
  buttonText = 'Avançar',
  cityId = 0,
  countries = [],
  countryId = 0,
  courseId = 1,
  id = 'widget-sales-executive',
  onMessageSuccess = () => {},
  onSubmitSecondStep = () => {},
  schoolsFilters = {},
  shouldScheduleMeeting = false,
  useParentProvider = false,
}) {
  const formContent = () => (
    <FormWrapper
      buttonText={buttonText}
      cityId={cityId}
      countries={countries}
      countryId={countryId}
      courseId={courseId}
      id={id}
      onMessageSuccess={onMessageSuccess}
      onSubmitSecondStep={onSubmitSecondStep}
      schoolsFilters={schoolsFilters}
      shouldScheduleMeeting={shouldScheduleMeeting}
    />
  );

  if (useParentProvider) {
    return formContent();
  }

  return (
    <LeadProvider
      shouldScheduleMeeting={shouldScheduleMeeting}
      countries={countries}
      schoolsFilters={schoolsFilters}
    >
      {formContent()}
    </LeadProvider>
  );
}

export default withFilterUtils(LeadForm);
